import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')

export default {
  name: 'hacchuEditSimple',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCalcDistance,
    DdCalcTankaButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDateBox,
    DdDropDown,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdSubHeader,
    DdTimeBoxSwitching,
    DdTextBox,
    DdTextBoxSwitching
  },
  data: () => ({
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {},

    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    baseYmd: '',
    mapData: [],

    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,

    recHacchusakiInfo: {},
    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders

  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // ----------------------------------------------------------------------------------------------------
    // マスタヘルプフィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 得意先
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 区分種別フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 往復種別
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcShiharaiKingakuAmount () {
      let amount = 0

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
      }

      return amount
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.rec.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.rec.unchinKeisanKbn === '01') {
        let hacchuSuryo = this.rec.hacchuSuryo
        if (hacchuSuryo === undefined || hacchuSuryo === '' || hacchuSuryo === null) { hacchuSuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(hacchuSuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '02') {
        let hacchuJuryo = this.rec.hacchuJuryo
        if (hacchuJuryo === undefined || hacchuJuryo === '' || hacchuJuryo === null) { hacchuJuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(hacchuJuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }
      amount = this.calcFraction(amount)
      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.rec) || this.rec.length === 0) { return 0 }

      let hokanKingaku = this.rec.hokanKingaku
      let niekiKingaku = this.rec.niekiKingaku
      let unchinHokaKingaku = this.rec.unchinHokaKingaku
      let nenryoSurcharge = this.rec.nenryoSurcharge
      let tsumikomiKingaku = this.rec.tsumikomiKingaku
      let torioroshiKingaku = this.rec.torioroshiKingaku
      let taikiJikanKingaku = this.rec.taikiJikanKingaku

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(hokanKingaku, 10) +
                parseInt(niekiKingaku, 10) +
                parseInt(unchinHokaKingaku, 10) +
                parseInt(nenryoSurcharge, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(torioroshiKingaku, 10) +
                parseInt(taikiJikanKingaku, 10)

      return amount
    },
    futaiGyomuKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.rec) || this.rec.length === 0) { return 0 }

      let futaiGyomuKingaku1 = this.rec.futaiGyomuKingaku1
      let futaiGyomuKingaku2 = this.rec.futaiGyomuKingaku2
      let futaiGyomuKingaku3 = this.rec.futaiGyomuKingaku3
      let futaiGyomuKingaku4 = this.rec.futaiGyomuKingaku4
      let futaiGyomuKingaku5 = this.rec.futaiGyomuKingaku5
      let futaiGyomuKingaku6 = this.rec.futaiGyomuKingaku6
      let futaiGyomuKingaku7 = this.rec.futaiGyomuKingaku7
      let futaiGyomuKingaku8 = this.rec.futaiGyomuKingaku8
      let futaiGyomuKingaku9 = this.rec.futaiGyomuKingaku9
      let futaiGyomuKingaku10 = this.rec.futaiGyomuKingaku10
      let futaiGyomuKingaku = this.rec.futaiGyomuKingaku

      if (futaiGyomuKingaku1 === undefined || futaiGyomuKingaku1 === '' || futaiGyomuKingaku1 === null) { futaiGyomuKingaku1 = '0' }
      if (futaiGyomuKingaku2 === undefined || futaiGyomuKingaku2 === '' || futaiGyomuKingaku2 === null) { futaiGyomuKingaku2 = '0' }
      if (futaiGyomuKingaku3 === undefined || futaiGyomuKingaku3 === '' || futaiGyomuKingaku3 === null) { futaiGyomuKingaku3 = '0' }
      if (futaiGyomuKingaku4 === undefined || futaiGyomuKingaku4 === '' || futaiGyomuKingaku4 === null) { futaiGyomuKingaku4 = '0' }
      if (futaiGyomuKingaku5 === undefined || futaiGyomuKingaku5 === '' || futaiGyomuKingaku5 === null) { futaiGyomuKingaku5 = '0' }
      if (futaiGyomuKingaku6 === undefined || futaiGyomuKingaku6 === '' || futaiGyomuKingaku6 === null) { futaiGyomuKingaku6 = '0' }
      if (futaiGyomuKingaku7 === undefined || futaiGyomuKingaku7 === '' || futaiGyomuKingaku7 === null) { futaiGyomuKingaku7 = '0' }
      if (futaiGyomuKingaku8 === undefined || futaiGyomuKingaku8 === '' || futaiGyomuKingaku8 === null) { futaiGyomuKingaku8 = '0' }
      if (futaiGyomuKingaku9 === undefined || futaiGyomuKingaku9 === '' || futaiGyomuKingaku9 === null) { futaiGyomuKingaku9 = '0' }
      if (futaiGyomuKingaku10 === undefined || futaiGyomuKingaku10 === '' || futaiGyomuKingaku10 === null) { futaiGyomuKingaku10 = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(futaiGyomuKingaku1, 10) +
                parseInt(futaiGyomuKingaku2, 10) +
                parseInt(futaiGyomuKingaku3, 10) +
                parseInt(futaiGyomuKingaku4, 10) +
                parseInt(futaiGyomuKingaku5, 10) +
                parseInt(futaiGyomuKingaku6, 10) +
                parseInt(futaiGyomuKingaku7, 10) +
                parseInt(futaiGyomuKingaku8, 10) +
                parseInt(futaiGyomuKingaku9, 10) +
                parseInt(futaiGyomuKingaku10, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.rec) || this.rec.length === 0) { return 0 }

      let hiwayPrice = this.rec.hiwayPrice
      let unchinHokaHikazei = this.rec.unchinHokaHikazei
      let tatekaekinHikazei = this.rec.tatekaekinHikazei

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (unchinHokaHikazei === undefined || unchinHokaHikazei === '' || unchinHokaHikazei === null) { unchinHokaHikazei = '0' }
      if (tatekaekinHikazei === undefined || tatekaekinHikazei === '' || tatekaekinHikazei === null) { tatekaekinHikazei = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10) + parseInt(tatekaekinHikazei, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.rec) || this.rec.length === 0) { return 0 }

      let jikanWarimashiKingaku = this.rec.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.rec.kyoriWarimashiKingaku
      let warimashiSonotaKingsku = this.rec.warimashiSonotaKingsku

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (warimashiSonotaKingsku === undefined || warimashiSonotaKingsku === '' || warimashiSonotaKingsku === null) { warimashiSonotaKingsku = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(warimashiSonotaKingsku, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10) + parseInt(this.futaiGyomuKingakuAmount, 10)

      return amount
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.rec.shiharaiZumiFlg) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisp () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && !this.rec.shiharaiZumiFlg) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.rec.shiharaiZumiFlg) {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.rec.hatsuchiId) ||
          (this.rec.keiyuchiId1) ||
          (this.rec.keiyuchiId2) ||
          (this.rec.keiyuchiId3) ||
          (this.rec.keiyuchiId4) ||
          (this.rec.keiyuchiId5) ||
          (this.rec.chakuchiId)) {
        return true
      }
      return false
    }
  },

  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },

  mounted () {
    this.initialize()
  },

  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // データ抽出処理
    // ----------------------------------------------------------------------------------------------------
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        // /* eslint no-debugger: "warn" */
        // debugger

        this.HttpClient
          .get(`/api/v1/VwCD2plod0050/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              const x = data.payload

              if (x.hacchuYmd) {
                x.hacchuYmd = filter.dateFormatter(x.hacchuYmd)
              }
              if (x.hacchusakiKbn === null) {
                x.hacchusakiKbn = '1'
              }
              if (x.hatsuchiYmd) {
                x.hatsuchiYmd = filter.dateFormatter(x.hatsuchiYmd)
              }
              if (x.hatsuchiHms) {
                x.hatsuchiHms = complements.parseTime(x.hatsuchiHms, false).substr(0, 5)
              }
              if (x.chakuchiYmd) {
                x.chakuchiYmd = filter.dateFormatter(x.chakuchiYmd)
              }
              if (x.chakuchiHms) {
                x.chakuchiHms = complements.parseTime(x.chakuchiHms, false).substr(0, 5)
              }
              if (x.shiharaiYoteiYmd) {
                x.shiharaiYoteiYmd = filter.dateFormatter(x.shiharaiYoteiYmd)
              }
              if (x.yoteiSagyoJikan != null) {
                x.yoteiSagyoJikan = filter.minToIntervalTimeFormatter(x.yoteiSagyoJikan)
              }
              if (x.taikiJikan != null) {
                x.taikiJikan = filter.minToIntervalTimeFormatter(x.taikiJikan)
              }
              if (x.warimashiTaishoJikan != null) {
                x.warimashiTaishoJikan = filter.minToIntervalTimeFormatter(x.warimashiTaishoJikan)
              }
              if (x.shiharaiYoteiYmd) {
                x.shiharaiYoteiYmd = filter.dateFormatter(x.shiharaiYoteiYmd)
              }
              this.rec = x

              if (this.rec.shiharaiZumiFlg) {
                this.setInvalidSummaryMessage('PLOI0006')
              }

              // 基準日設定
              this.baseYmd = filter.dateFormatter(this.rec.hacchuYmd)

              // クローン情報設定
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期化処理
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            // 権限制御
            if (kengen.kengenKbn === '10') {
              self.modeKengen = 0 // 読取モード
            } else if (kengen.kengenKbn === '20') {
              self.modeKengen = 1 // 削除不可モード
            } else {
              self.modeKengen = 2 // フルアクセス
            }

            // 画面モード設定
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForRegister(option)
    },

    // ----------------------------------------------------------------------------------------------------
    // 固定貨物No反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    // ポップアップから選択時
    koteiKamostuNoDialogSync: function (p) {
      console.log(' **** XXXXX **** koteiKamostuNoDialogSync', p)
      this.rec.teikeiKihonNo = p
      this.getKoteiKamotsuInfo()
    },
    // 反映ボタン押下時
    koteiKamostuNoSync: function (p) {
      console.log(' **** XXXXX **** koteiKamostuNoSync', p)
      this.getKoteiKamotsuInfo()
    },
    getKoteiKamotsuInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/Thrcod00100/KoteiKamotsuInfoFind?koteiKamotsuNo=${this.rec.teikeiKihonNo}`)
          .then((data) => {
            if (data.payload) {
              // ==================================================
              // 貨物基本情報
              // ==================================================-
              this.tempHaisoMeisai = this.rec
              this.rec = {}
              const inputData = {
                hacchuSuryo: '',
                hacchuJuryo: '',
                tanka: ''
              }

              if (data.payload.vwhacchuKihon) {
                inputData.hacchuEigyoshoId = data.payload.vwhacchuKihon.hacchuEigyoshoId
                inputData.hacchusakiId = data.payload.vwhacchuKihon.ninushiId
                inputData.hatsuchiId = data.payload.vwhacchuKihon.hatsuchiId
                inputData.hatsuchiBiko = data.payload.vwhacchuKihon.hatsuchiBiko
                inputData.hatsuchiHmsBiko = data.payload.vwhacchuKihon.hatsuchiHmsBiko
                inputData.chakuchiId = data.payload.vwhacchuKihon.chakuchiId
                inputData.chakuchiBiko = data.payload.vwhacchuKihon.chakuchiBiko
                inputData.chakuchiHmsBiko = data.payload.vwhacchuKihon.chakuchiHmsBiko
                inputData.shiharaiShashuSbt = data.payload.vwhacchuKihon.shiharaiShashuSbt

                if (data.payload.vwhacchuKihon.hatsuchiHms) { inputData.hatsuchiHms = (data.payload.vwhacchuKihon.hatsuchiHms).slice(0, 5) }

                if (data.payload.vwhacchuKihon.chakuchiHms) { inputData.chakuchiHms = (data.payload.vwhacchuKihon.chakuchiHms).slice(0, 5) }

                if (!inputData.hatsuchiId && inputData.hatsuchiBiko) { this.hatsuchiSwitch = true }

                if (!inputData.hatsuchiHms && inputData.hatsuchiHmsBiko) { this.hatsuchiHmsSwitch = true }

                if (!inputData.chakuchiId && inputData.chakuchiBiko) { this.chakuchiSwitch = true }

                if (!inputData.chakuchiHms && inputData.chakuchiHmsBiko) { this.chakuchiHmsSwitch = true }
              }
              // ==================================================
              // 商品情報
              // ==================================================
              if (data.payload.vwhacchuHinmokuList) {
                inputData.mstHinmeiId = data.payload.vwhacchuHinmokuList[0].mstHinmeiId
                inputData.hinmeiBiko = data.payload.vwhacchuHinmokuList[0].hinmeiBiko
                inputData.hacchuSuryo = data.payload.vwhacchuHinmokuList[0].hacchuSuryo
                inputData.unitKbn = data.payload.vwhacchuHinmokuList[0].unitKbn
                inputData.hacchuJuryo = data.payload.vwhacchuHinmokuList[0].hacchuJuryo
                inputData.tanka = data.payload.vwhacchuHinmokuList[0].tanka
              }
              if (this.tempHaisoMeisai.shiharaiYoteiYmd) {
                inputData.shiharaiYoteiYmd = this.tempHaisoMeisai.shiharaiYoteiYmd
              } else {
                inputData.shiharaiYoteiYmd = filter.dateFormatter(new Date())
              }
              inputData.id = this.tempHaisoMeisai.id
              inputData.tjkUpdDate = this.tempHaisoMeisai.tjkUpdDate

              inputData.tjmId = this.tempHaisoMeisai.tjmId
              inputData.tjmUpdDate = this.tempHaisoMeisai.tjmUpdDate

              inputData.tjhId = this.tempHaisoMeisai.tjhId
              inputData.tjhUpdDate = this.tempHaisoMeisai.tjhUpdDate

              inputData.tjkKinId = this.tempHaisoMeisai.tjkKinId
              inputData.tjkKinUpdDate = this.tempHaisoMeisai.tjkKinUpdDate

              inputData.tjmKinId = this.tempHaisoMeisai.tjmKinId
              inputData.tjmKinUpdDate = this.tempHaisoMeisai.tjmKinUpdDate

              inputData.tjhKinId = this.tempHaisoMeisai.tjhKinId
              inputData.tjhKinUpdDate = this.tempHaisoMeisai.tjhKinUpdDate

              inputData.tjrKihonId = this.tempHaisoMeisai.tjrKihonId
              inputData.tjrKihonUpdDate = this.tempHaisoMeisai.tjrKihonUpdDate

              inputData.tjrMeisaiId = this.tempHaisoMeisai.tjrMeisaiId
              inputData.tjrMeisaiUpdDate = this.tempHaisoMeisai.tjrMeisaiUpdDate

              inputData.tsmId = this.tempHaisoMeisai.tsmId
              inputData.tsmUpdDate = this.tempHaisoMeisai.tsmUpdDate

              inputData.tskId = this.tempHaisoMeisai.tskId
              inputData.tskUpdDate = this.tempHaisoMeisai.tskUpdDate

              inputData.thkId = this.tempHaisoMeisai.thkId
              inputData.thkUpdDate = this.tempHaisoMeisai.thkUpdDate

              inputData.thmId = this.tempHaisoMeisai.thmId
              inputData.thmUpdDate = this.tempHaisoMeisai.thmUpdDate

              inputData.thkKinId = this.tempHaisoMeisai.thkKinId
              inputData.thkKinUpdDate = this.tempHaisoMeisai.thkKinUpdDate

              inputData.thmKinId = this.tempHaisoMeisai.thmKinId
              inputData.thmKinUpdDate = this.tempHaisoMeisai.thmKinUpdDate

              inputData.hacchuNo = this.tempHaisoMeisai.hacchuNo
              inputData.meisaiOrder = this.tempHaisoMeisai.meisaiOrder
              inputData.teikeiKihonNo = this.tempHaisoMeisai.teikeiKihonNo

              this.rec = Object.assign({}, inputData)
            } else {
              this.$refs.teikeiKihonNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMI0101'))
            }
            resolve()
          })
      })
    },

    onCourseRirekiClick: function () {
      this.$refs.teikeiKihonNo.onDialogButtonClick()
    },

    // ----------------------------------------------------------------------------------------------------
    // 戻るボタン押下
    // ----------------------------------------------------------------------------------------------------
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2plod0050/DeleteHacchuInfo', self.rec).then((data) => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },

    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()

        const x = this.rec
        x.id = -1
        x.tjmId = null
        x.tjhId = null
        x.tjkKinId = null
        x.tjmKinId = null
        x.tjhKinId = null
        x.tjrKihonId = null
        x.tjrMeisaiId = null
        x.tsmId = null
        x.tskMeisaiId = null
        x.tshId = null
        x.tskHinmokuId = null
        x.thkId = null
        x.thmId = null
        x.thkKinId = null
        x.thmKinId = null
        x.hacchuNo = null
        x.meisaiOrder = null
        x.shiharaiZumiFlg = false

        this.rec = x
        this.modeOfEdit = 0
        this.Effects.loadComplete()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      self.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2plod0050/CreatehacchuInfo', this.rec)
      return f
    },
    registerValidate: function () {
      return true
    },
    convertToDBType: function () {
      if (this.rec.taikiJikan) {
        this.rec.taikiJikan = filter.timeToMinFormatter(this.rec.taikiJikan)
      }
      if (this.rec.yoteiSagyoJikan) {
        this.rec.yoteiSagyoJikan = filter.timeToMinFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan) {
        this.rec.warimashiTaishoJikan = filter.timeToMinFormatter(this.rec.warimashiTaishoJikan)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // GoogleMapリンク
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if (![undefined, null, ''].includes(this.rec.hatsuchiId) || ![undefined, null, ''].includes(this.rec.hatsuchiBiko)) {
        const hatsuchi = {
          id: this.rec.hatsuchiId,
          biko: this.rec.hatsuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.rec.keiyuchiId1) || ![undefined, null, ''].includes(this.rec.keiyuchiBiko1)) {
        const keiyuchi = {
          id: this.rec.keiyuchiId1,
          biko: this.rec.keiyuchiBiko1,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.rec.keiyuchiId2) || ![undefined, null, ''].includes(this.rec.keiyuchiBiko2)) {
        const keiyuchi = {
          id: this.rec.keiyuchiId2,
          biko: this.rec.keiyuchiBiko2,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.rec.keiyuchiId3) || ![undefined, null, ''].includes(this.rec.keiyuchiBiko3)) {
        const keiyuchi = {
          id: this.rec.keiyuchiId3,
          biko: this.rec.keiyuchiBiko3,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.rec.keiyuchiId4) || ![undefined, null, ''].includes(this.rec.keiyuchiBiko4)) {
        const keiyuchi = {
          id: this.rec.keiyuchiId4,
          biko: this.rec.keiyuchiBiko4,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.rec.keiyuchiId5) || ![undefined, null, ''].includes(this.rec.keiyuchiBiko5)) {
        const keiyuchi = {
          id: this.rec.keiyuchiId5,
          biko: this.rec.keiyuchiBiko5,
          ymdhms: (![undefined, null, ''].includes(this.rec.hatsuchiYmd) ? this.rec.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.hatsuchiHms) ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if (![undefined, null, ''].includes(this.rec.chakuchiId) || ![undefined, null, ''].includes(this.rec.chakuchiBiko)) {
        const chakuchi = {
          id: this.rec.chakuchiId,
          biko: this.rec.chakuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.rec.chakuchiYmd) ? this.rec.chakuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.rec.chakuchiHms) ? this.rec.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },
    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.rec.hatsuchiId,
        hatsuchiBiko: this.rec.hatsuchiBiko,
        keiyuchiId1: this.rec.keiyuchiId1,
        keiyuchiBiko1: this.rec.keiyuchiBiko1,
        keiyuchiId2: this.rec.keiyuchiId2,
        keiyuchiBiko2: this.rec.keiyuchiBiko2,
        keiyuchiId3: this.rec.keiyuchiId3,
        keiyuchiBiko3: this.rec.keiyuchiBiko3,
        keiyuchiId4: this.rec.keiyuchiId4,
        keiyuchiBiko4: this.rec.keiyuchiBiko4,
        keiyuchiId5: this.rec.keiyuchiId5,
        keiyuchiBiko5: this.rec.keiyuchiBiko5,
        chakuchiId: this.rec.chakuchiId,
        chakuchiBiko: this.rec.chakuchiBiko
      }

      // 既存値初期化
      this.rec.hatsuchiId = null
      this.rec.hatsuchiBiko = null
      this.rec.keiyuchiId1 = null
      this.rec.keiyuchiBiko1 = null
      this.rec.keiyuchiId2 = null
      this.rec.keiyuchiBiko2 = null
      this.rec.keiyuchiId3 = null
      this.rec.keiyuchiBiko3 = null
      this.rec.keiyuchiId4 = null
      this.rec.keiyuchiBiko4 = null
      this.rec.keiyuchiId5 = null
      this.rec.keiyuchiBiko5 = null
      this.rec.chakuchiId = null
      this.rec.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId)) {
        this.rec.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.rec.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId)) {
        this.rec.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.rec.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5)) {
        this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId3)) {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.rec.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId3)) {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId4)) {
          this.rec.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.rec.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.baseYmd = date.getCurrentDate()
      // 入力項目
      this.$set(this.rec, 'hacchuYmd', this.baseYmd)
      this.rec.hacchuEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.userEigyoshoCd, this.baseYmd).id : null
      this.rec.sagyoEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.userEigyoshoCd, this.baseYmd).id : null
      this.$set(this.rec, 'shiharaiYoteiYmd', this.baseYmd)
      this.rec.hacchusakiKbn = '1'

      // ドロップダウン
      this.$set(this.rec, 'ohfukuSbt', null)
      this.$set(this.rec, 'unitKbn', null)
      this.$set(this.rec, 'unchinKeisanKbn', null)
      this.$set(this.rec, 'shiharaiShashuSbt', null)

      // 入力制御
      this.modeKengen = 0
      this.modeOfEdit = 0
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeHacchusaki: function () {
      if (!this.rec.hacchusakiId) { return }
      console.log('changeHacchusakiId')
      this.rec.torihikisakiCd = indexeddb.getRecord(this.torihikisakiList, this.rec.hacchusakiId).torihikisakiCd

      this.getHacchusakiInfo(this.rec.hacchusakiId)
    },
    getHacchusakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2PLOD0050/HacchusakiInfoFind?id=${this.rec.hacchusakiId}`)
          .then((data) => {
            this.recHacchusakiInfo = data.payload
            console.log('getHacchusakiInfo', this.recHacchusakiInfo)
            this.initShiharaiYoteiYmd()
            if (!this.rec.unchinKeisanKbn && this.recHacchusakiInfo.unchinKeisanKbn) {
              this.$set(this.rec, 'unchinKeisanKbn', this.recHacchusakiInfo.unchinKeisanKbn)
            }
            this.rec.warimashiJikanTanka = this.rec.warimashiJikanTanka ? this.rec.warimashiJikanTanka : this.recHacchusakiInfo.warimashiJikanTanka
            this.rec.warimashiKyoriTanka = this.rec.warimashiKyoriTanka ? this.rec.warimashiKyoriTanka : this.recHacchusakiInfo.warimashiKyoriTanka
            this.calcJikanWarimashiKingaku()
            this.calcKyoriWarimashiKingaku()
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求予定日初期値設定
    // ----------------------------------------------------------------------------------------------------
    initShiharaiYoteiYmd: function () {
      const keijobiKbn = this.recHacchusakiInfo.keijobiKbn

      if (keijobiKbn === undefined || keijobiKbn === '') { return }

      if (this.rec.shiharaiYoteiYmd !== filter.dateFormatter(new Date()) && !this.rec.meisaiOrder) { return }

      if (this.rec.shiharaiYoteiYmd && this.rec.meisaiOrder) { return }

      if (keijobiKbn === '1' && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' && this.rec.hatsuchiYmd !== undefined) {
        this.$refs.shiharaiYoteiYmd.onCalendarInput(this.rec.hatsuchiYmd)
      } else if (keijobiKbn === '2' && this.rec.chakuchiYmd !== null && this.rec.chakuchiYmd !== '' && this.rec.chakuchiYmd !== undefined) {
        this.$refs.shiharaiYoteiYmd.onCalendarInput(this.rec.chakuchiYmd)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目切替
    // ----------------------------------------------------------------------------------------------------
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },

    // ----------------------------------------------------------------------------------------------------
    // フィルタ補助
    // ----------------------------------------------------------------------------------------------------
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },

    // ----------------------------------------------------------------------------------------------------
    // 距離計算補助
    // ----------------------------------------------------------------------------------------------------
    setYoteiSokoKyori: function (e) {
      this.$set(this.rec, 'yoteiSokoKyori', e.kyoriKm)
    },
    // ----------------------------------------------------------------------------------------------------
    // 時間計算補助
    // ----------------------------------------------------------------------------------------------------
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToTimeFormatter(min)
      }
      return result
    },
    // ----------------------------------------------------------------------------------------------------
    // 請求補助
    // ----------------------------------------------------------------------------------------------------
    inputTaikiJikan: function () {
      if (this.rec.taikiJikan) {
        this.$set(this.rec, 'taikiJikan', this.calcTime(String(this.rec.taikiJikan)))
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.rec.taikiJikan
      let taikiJikanTanka = this.rec.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.rec, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    inputYoteiSagyoJikan: function () {
      if (this.rec.yoteiSagyoJikan) {
        this.$set(this.rec, 'yoteiSagyoJikan', this.calcTime(String(this.rec.yoteiSagyoJikan)))
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.rec)
      temp = {
        ...temp,
        /*
        juchuEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.juchuEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingsku: e.userKingakuKazei2
      }
      this.rec = Object.assign({}, temp)
      temp = undefined
    },

    // ----------------------------------------------------------------------------------------------------
    // 割増補助
    // ----------------------------------------------------------------------------------------------------
    inputWarimashiTaishoJikan: function () {
      if (this.rec.warimashiTaishoJikan) {
        this.$set(this.rec, 'warimashiTaishoJikan', this.calcTime(String(this.rec.warimashiTaishoJikan)))
      }
    },
    calcJikanWarimashiKingaku: function () {
      if (this.rec.warimashiTaishoJikan && this.rec.warimashiJikanTanka) {
        let warimashiTaishoJikan = this.rec.warimashiTaishoJikan
        let warimashiJikanTanka = this.rec.warimashiJikanTanka

        if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '') { warimashiTaishoJikan = 0 }
        if (warimashiJikanTanka === undefined || warimashiJikanTanka === '') { warimashiJikanTanka = 0 }

        warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)
        const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
        this.$set(this.rec, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
      } else {
        this.$set(this.rec, 'jikanWarimashiKingaku', null)
      }
    },
    calcKyoriWarimashiKingaku: function () {
      if (this.rec.warimashiTaishoKyori && this.rec.warimashiKyoriTanka) {
        let warimashiTaishoKyori = this.rec.warimashiTaishoKyori
        let warimashiKyoriTanka = this.rec.warimashiKyoriTanka

        if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '') { warimashiTaishoKyori = 0 }
        if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '') { warimashiKyoriTanka = 0 }

        const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
        this.$set(this.rec, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
      } else {
        this.$set(this.rec, 'kyoriWarimashiKingaku', null)
      }
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.recHacchusakiInfo) || [undefined, null, ''].includes(this.recHacchusakiInfo.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.recHacchusakiInfo.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.recHacchusakiInfo.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.recHacchusakiInfo.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    setHacchuEigyosho: function () {
      if (this.rec.hacchuEigyoshoId) {
        this.rec.hacchuEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.rec.hacchuEigyoshoId).eigyoshoCd
      }
    },
    setHinmei: function () {
      if (this.rec.mstHinmeiId) {
        this.rec.hinmeiCd = indexeddb.getRecord(this.hinmeiList, this.rec.mstHinmeiId).hinmeiCd
      }
    },
    setHatsuchiId: function () {
      if (this.rec.hatsuchiId) {
        this.rec.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.rec.hatsuchiId).hacchakuchiCd
      }
    },
    setChakuchiId: function () {
      if (this.rec.chakuchiId) {
        this.rec.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.rec.chakuchiId).hacchakuchiCd
      }
    }
  }
}
